(function (context) {
    function process() {
        Promise.all(Array.from(context.querySelectorAll('svg.replace-symbol')).map(svgNode => {
            svgNode.classList.remove('replace-symbol');
            return new Promise((resolve, reject) => {
                const useElement = svgNode.children[0] ?? null;
                if (!(useElement instanceof Element) || useElement.tagName.toUpperCase() !== "USE") {
                    return reject(new Error('can not find use element inside svg node with replace-symbol class'));
                }
                const fullUrl = svgNode.childNodes[0].getAttribute('href');
                const fragmentPosition = fullUrl.indexOf('#');
                const url = fragmentPosition > -1 ? fullUrl.substr(0, fragmentPosition) : fullUrl;
                fetch(url).then(response => {
                    if (response.ok) {
                        response.text().then(symbolMarkup => {
                            const svgDocument = new DOMParser().parseFromString(symbolMarkup, "image/svg+xml");
                            svgDocument.documentElement.removeAttribute('id');
                            svgNode.classList.forEach(className => {
                                svgDocument.documentElement.classList.add(className);
                            });
                            svgDocument.documentElement.classList.add('symbol-replaced');
                            if (svgNode.hasAttribute('width')) {
                                svgDocument.documentElement.setAttribute('width', svgNode.getAttribute('width'));
                            }
                            if (svgNode.hasAttribute('height')) {
                                svgDocument.documentElement.setAttribute('height', svgNode.getAttribute('height'));
                            }
                            svgNode.parentNode.replaceChild(svgDocument.documentElement, svgNode);
                            resolve();
                        });
                    } else {
                        reject(new Error(`response status for ${url} not ok`));
                    }
                }).catch(reject);
            });
        }));
    }
    process();
    const observer = new MutationObserver(process);
    observer.observe(context, {
        childList: true,
        subtree: true,
    });
})(document);
